import { z } from "zod";
import { CollectNodeFieldTypeEnum } from "../../../../enum/nodes.enum";

export const collectNodeFileFieldSchema = z.object({
  type: z.literal(CollectNodeFieldTypeEnum.FILE),
  acceptedImageTypes: z.array(z.string()).default([]).optional(),
  acceptedVideoTypes: z.array(z.string()).default([]).optional(),
  acceptedDocumentTypes: z.array(z.string()).default([]).optional(),
});
